import React from "react";
const Card = ({ name, role, experience, image_path, more }) => {
  return (
    <div className="rounded px-4 py-4 bg-white mx-4 shadow-md my-4 sm:mx-8">
      <img
        src={image_path}
        alt="Member"
        className={`w-full h-64 object-cover rounded ${
          name === "Quilan Padgham" ? "object-top" : ""
        }`}
      />
      <div className="pt-2 sm:px-2 md:py-4">
        <h1 className="font-semibold">{name}</h1>
        <div>
          <h1 className=" text-gray-800">Role </h1>
          <h1 className="text-gray-600 text-sm">{role}</h1>
        </div>
        <div>
          <h1 className=" text-gray-800">Experience </h1>
          <h1 className="text-gray-600 text-sm">{experience}</h1>
        </div>
        <div>
          <h1 className=" text-gray-800">About me </h1>
          <h1 className="text-gray-600 text-sm">{more}</h1>
        </div>
      </div>
    </div>
  );
};

export default Card;
